const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMinWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1362 1362",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlXpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(0.665039,0,0,0.665039,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2048,
    height: 2048,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2537.09,0,0,2537.09,-44.1197,1911.98)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.422,0.01c-0.055,0 -0.105,-0.009 -0.151,-0.027c-0.046,-0.018 -0.086,-0.043 -0.12,-0.075c-0.034,-0.033 -0.06,-0.071 -0.079,-0.114c-0.019,-0.044 -0.028,-0.092 -0.028,-0.144c-0,-0.052 0.009,-0.1 0.028,-0.143c0.019,-0.044 0.045,-0.082 0.079,-0.114c0.034,-0.033 0.074,-0.058 0.12,-0.076c0.046,-0.018 0.096,-0.027 0.15,-0.027c0.055,0 0.105,0.009 0.15,0.027c0.046,0.018 0.086,0.043 0.12,0.076c0.034,0.032 0.06,0.07 0.079,0.114c0.019,0.043 0.028,0.091 0.028,0.143c0,0.052 -0.009,0.1 -0.028,0.144c-0.019,0.044 -0.045,0.082 -0.079,0.114c-0.034,0.032 -0.074,0.057 -0.12,0.075c-0.045,0.018 -0.095,0.027 -0.149,0.027Zm-0.001,-0.114c0.035,0 0.068,-0.006 0.098,-0.018c0.03,-0.012 0.056,-0.029 0.078,-0.051c0.022,-0.023 0.039,-0.049 0.051,-0.078c0.013,-0.03 0.019,-0.063 0.019,-0.099c0,-0.036 -0.006,-0.069 -0.019,-0.098c-0.012,-0.03 -0.029,-0.056 -0.051,-0.078c-0.022,-0.023 -0.048,-0.04 -0.078,-0.052c-0.03,-0.012 -0.063,-0.018 -0.098,-0.018c-0.035,0 -0.068,0.006 -0.098,0.018c-0.029,0.012 -0.055,0.029 -0.078,0.052c-0.022,0.022 -0.039,0.048 -0.052,0.078c-0.012,0.029 -0.018,0.062 -0.018,0.098c-0,0.035 0.006,0.068 0.018,0.098c0.013,0.03 0.03,0.056 0.052,0.079c0.022,0.022 0.048,0.039 0.078,0.051c0.03,0.012 0.063,0.018 0.098,0.018Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.40472,0,0,1.40472,-219.892,-256.361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M777.223,839.091c-15.744,0 -30.24,-2.592 -43.488,-7.776c-13.248,-5.184 -24.768,-12.384 -34.56,-21.6c-9.792,-9.408 -17.376,-20.352 -22.752,-32.832c-5.376,-12.672 -8.064,-26.496 -8.064,-41.472c-0,-14.976 2.688,-28.704 8.064,-41.184c5.376,-12.672 12.96,-23.616 22.752,-32.832c9.792,-9.408 21.312,-16.704 34.56,-21.888c13.248,-5.184 27.648,-7.776 43.2,-7.776c15.744,-0 30.144,2.592 43.2,7.776c13.248,5.184 24.768,12.48 34.56,21.888c9.792,9.216 17.376,20.16 22.752,32.832c5.376,12.48 8.064,26.208 8.064,41.184c-0,14.976 -2.688,28.8 -8.064,41.472c-5.376,12.672 -12.96,23.616 -22.752,32.832c-9.792,9.216 -21.312,16.416 -34.56,21.6c-13.056,5.184 -27.36,7.776 -42.912,7.776Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMinWhite);
export default __webpack_public_path__ + "static/media/logo_min_white.6fe02db8fa2fcf3df34ae9d024e72600.svg";
export { ForwardRef as ReactComponent };